export enum LocalStorageKeys {
  TASKS_VIEW = 'tasksView',
  APP_VERSION = 'appVersion'
}
